/** Encode serial numbers for use in URL path segments (e.g. `#` → `%23`). */
export function encodeMachineSerialForRoute(serialNumber: string): string {
	return encodeURIComponent(serialNumber);
}

/** Decode a machine serial from a route param. */
export function decodeMachineSerialFromRoute(id: string | undefined): string {
	if (!id) return '';
	try {
		return decodeURIComponent(id);
	} catch {
		return id;
	}
}

export function machineDetailPath(serialNumber: string): string {
	return `/machines/${encodeMachineSerialForRoute(serialNumber)}`;
}

export function machineWarrantyRegistrationPath(serialNumber: string): string {
	return `${machineDetailPath(serialNumber)}/warranty-registration`;
}
